export enum PortalNotificationsEnum {
  UsersJoined = 'NotifyUsersJoined',
  UserLeft = 'NotifyUserLeft'
}
